import { ContactPhoneNumberModel, ContactAddressModel, AccountModel, ImpersonatorModel, FansModel } from './index';

export class UserProfileModel {

  contactPhoneNumber: ContactPhoneNumberModel;
  userId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  companyId: string;
  fanList: Array<string>;
  roles: string;
  permission: string;
  impersonator: ImpersonatorModel;
  clientIPAddress: string;
  fans: Array<FansModel>;
  addpAuthority: string;
  fanSignedUpStatus: string;
}
